import {otmsHttp} from '@/utils/http/index.js'

/**
 * POI列表
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/8552
 */
export function poiSearch(data) {
  return otmsHttp.post('/poi/list',data)
}

/**
 * POI列表
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/8552
 */
export function poiSearch2(data) {
  return otmsHttp.post('/poi/list',data)
}


